<loading-status></loading-status>
@if (article$ | async; as article) {
<ng-scrollbar class="ngr-scrollbar">
  @if (article.title) {
  @let firstDayArticle = isFirstDayArticle(article.attributes, article.extras.situations) ;
  <div style="max-width: 1140px; margin: 0 auto;" id="top">
    <section class="__content px-2">
      <h1 [innerHTML]="splitTitle(article.title)"></h1>
      <div class="row attributes p-0 pb-1">
        <div class="col">
          <ul class="list-inline mb-0">
            <li class="list-inline-item">
              <div class="pt-1">
                {{article.publicationDate | date:'medium'}}
              </div>
            </li>
            @for (attributeSet of article.attributes | keyvalue; track attributeSet) {
            @for (attribute of attributeSet.value; track attribute) {
            <li class="list-inline-item">
              <button type="button" [className]="attributeNameToColour(attributeSet.key)" (click)="attributeClick($event, attributeSet.key, attribute.value)">{{attribute.name}}</button>
            </li>
            }
            }
          </ul>
        </div>
        <div class="col-auto">
          <app-header class="__header" [showBack]="true" [article]="article" [title]="''" [backRoute]="'..'" [contentSet]="area" [showFollow]="false"></app-header>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col">
          @if (firstDayArticle) {
          <div class="case-info-box">
            <div class="card border-bd-green-colour">
              @let firstDayCaseArticle = article.extras.situations[0];
              <div class="card-body text-primary">
                <followable-link area="situations" [articleid]="firstDayCaseArticle.case_id" [label]="firstDayCaseArticle.case_name" size="20px"></followable-link>
                <ul class="list-unstyled">
                  <li><strong>Filing Type</strong>: Chapter {{firstDayCaseArticle.case_filing_type}}</li>
                  <li><strong>Industry</strong>: {{firstDayCaseArticle.case_industry}}</li>
                  <li><strong>Court</strong>: {{firstDayCaseArticle.court_name.replace('Bankruptcy Court', '')}}</li>
                  <li><strong>Judge</strong>: {{firstDayCaseArticle.judges}}</li>
                  <ng-container *ngTemplateOutlet="situationListItems; context: {$implicit: firstDayCaseArticle}"></ng-container>
                  @if (firstDayCaseArticle.first_day_filings_asset) {
                  <a [href]="firstDayCaseArticle.first_day_filings_asset" class="btn btn-gradient" target="_blank">Get First Day Documents</a>
                  }
                </ul>
              </div>
            </div>
          </div>
          }
          <content-viewer [content]="article.body"></content-viewer>
        </div>
      </div>
      @if (article.extras; as extras) {
      @if (extras && extras.commonStockInstrumentID! > 0) {
      <div class="col-12">
        <app-equity-pricing-graph [id]="extras.commonStockInstrumentID!" class="row"></app-equity-pricing-graph>
      </div>
      }

      <div class="row">
        @if (extras.situations!.length > 0) {
        <div class="col-md-6">
          <h2>Situations</h2>
          @for (situation of extras.situations; track situation) {
          @if (situation.situation === 'bankruptcy') {
          <div class="card border-bd-green-colour mb-3">
            <div class="card-header h4 follower">
              @if (situation.public_private === 'Yes') {
              <followable-link area="situations" [articleid]="situation.case_id" [label]="situation.case_name" size="18px" extra="SEC Documents"></followable-link>
              }
              @else {
              <followable-link area="situations" [articleid]="situation.case_id" [label]="situation.case_name" size="18px"></followable-link>
              }
            </div>
            <div class="card-body text-primary">
              <ul class="list-unstyled">
                <li><strong>Filing Type</strong>: Chapter {{situation.case_filing_type}}</li>
                <li><strong>Status</strong>: {{situation.case_status}}</li>
                <li><strong>Industry</strong>: {{situation.case_industry}}</li>
                <li><strong>Court</strong>: {{situation.court_name}}</li>
                <li><strong>Case no</strong>: {{situation.case_number}}</li>
                <li><strong>Judge</strong>: {{situation.judges}}</li>
                <ng-container *ngTemplateOutlet="situationListItems; context: {$implicit: situation}"></ng-container>
              </ul>
            </div>
          </div>

          }
          @else {

          <div class="card border-bd-green-colour mb-3">
            @let situationID = situation.situationname_cell?.situation_article_id ?? situation.situation_article_id;
            <div class="card-header h4 follower">
              @if (situation.public_private === 'Yes') {
              <followable-link area="situations" [articleid]="situationID" [label]="situation.entity_name" size="18px" extra="SEC Documents"></followable-link>
              } @else {
              <followable-link area="situations" [articleid]="situationID" [label]="situation.entity_name" size="18px"></followable-link>
              }
            </div>
            <div class="card-body text-primary">
              <ul class="list-unstyled">
                <ng-container *ngTemplateOutlet="situationListItems; context: {$implicit: situation}"></ng-container>
              </ul>
              <situation-timeline [timeline]="situation.timeline" [highlightSituationID]="situationID" [linkall]="true">
                <h3 class="column-header">TIMELINE</h3>
              </situation-timeline>

            </div>
          </div>
          }
          }
        </div>
        }
        @if (extras.article_companies_people?.People?.length) {
        <div class="col-md-6">
          <h2>People</h2>
          @for (person of extras.article_companies_people?.People; track person) {

          <div class="card border-bd-green-colour mb-3">
            <div class="card-header"><a [routerLink]="'/people/' + person.articleID">{{person.name}}</a></div>
            <div class="card-body text-primary">
              <div class="row">
                @if (person.personData.linkedin?.length > 10) {
                <div class="col-sm-auto">
                  <linked-in [handle]="getLinkedInHandle(person.personData.linkedin)"></linked-in>
                </div>
                }
                <div class="col">
                  <ul class="list-unstyled">
                    @if (person.personData.telephone) {
                    <li><a href="tel:{{person.personData.telephone}}"><i-bs [name]="iconNames.TelephoneOutbound"></i-bs>&nbsp;{{person.personData.telephone | phone:'US'}}</a></li>
                    }
                    @if (person.personData.email) {
                    <li><a href="email:{{person.personData.email}}"><i-bs [name]="iconNames.EnvelopeAt"></i-bs>&nbsp;{{person.personData.email}}</a></li>
                    }
                    @if (person.personData.web) {
                    <li><a target="_blank" [href]="person.personData.web"><i-bs [name]="iconNames.BrowserChrome"></i-bs>&nbsp;Website</a></li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>

          }
        </div>
        }
        @if (extras.article_companies_people?.Companies?.length) {
        <div class="col-md-6">
          <h2>Organizations</h2>
          @for (company of extras.article_companies_people?.Companies; track company) {

          <div class="card border-bd-green-colour mb-3">
            <div class="card-header"><a [routerLink]="'/organizations/' + company.articleID">{{company.name}}</a></div>
            <div class="card-body text-primary">
              <div class="row">
                <div class="col">
                  <ul class="list-unstyled">
                    @if (company.dominant_industry) {
                    <li><strong>Industry</strong>: {{company.dominant_industry}}</li>
                    }
                    @if (company.assets_range) {
                    <li><strong>Assets</strong>: {{company.assets_range}}</li>
                    }
                    @if (company.liabilities_range) {
                    <li><strong>Liabilities</strong>: {{company.liabilities_range}}</li>
                    }
                    @if (company.revenue_range) {
                    <li><strong>Revenue</strong>: {{company.revenue_range}}</li>
                    }
                    @if (company.employees_range) {
                    <li><strong>Employees</strong>: {{company.employees_range}}</li>
                    }
                    @if (company.creditors_range) {
                    <li><strong>Creditors</strong>: {{company.creditors_range}}</li>
                    }
                    @if (company.parents?.length) {
                    <div>
                      @for (aparent of company.parents; track aparent) {
                      <div>
                        <li><strong>{{aparent.relation}} of </strong>: <a [routerLink]="'/organizations/' + aparent.articleID">{{aparent.name}}</a></li>
                      </div>
                      }
                    </div>
                    }
                    @if (company.children?.length) {
                    <div>
                      @for (achild of company.children; track achild) {
                      <div>
                        <li><strong>{{achild.relation}}</strong>: <a [routerLink]="'/organizations/' + achild.articleID">{{achild.name}}</a></li>
                      </div>
                      }
                    </div>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>

          }
        </div>
        }


        @if (extras && extras.court_documents && extras.court_documents.length > 0) {
        <div class="col-md-6">
          <h2>Source documents</h2>
          <court-documents [documents]="extras.court_documents" colsDefn="" [showHeader]="false"></court-documents>
        </div>
        }
        @if (extras && extras.sec_documents && extras.sec_documents.length > 0) {
        <div class="col-md-6">
          <h2>SEC documents</h2>
          <sec-documents-block [documents]="extras.sec_documents" colsDefn=""></sec-documents-block>
        </div>
        }
      </div>
      @if (extras.relatedNews?.length) {
      <div class="row">
        <div class="col">
          <h2>More news for {{extras.relatedNewsTypeDetails.name}}</h2>
          <ul class="list-group list-group-flush w-100">
            @for (article of extras.relatedNews; track trackbyArticleID(i, article); let i = $index) {

            <li class="list-group-item article-display">
              <div [libMasterRouterLink]="['news' , article.id]" [id]="'article_' + article.id" [queryParams]="getQueryParams(extras.relatedNewsTypeDetails)">
                <app-list-item [article]="article" [isSelected]="false" [showAttributes]="false" [dateFormat]="'medium'"></app-list-item>
              </div>
            </li>

            }
          </ul>
          <button class="btn btn-gradient d-block" style="margin: 0 auto" [libMasterRouterLink]="['news']" [queryParams]="getQueryParams(extras.relatedNewsTypeDetails)">Show all news for {{ extras.relatedNewsTypeDetails.name }}</button>
        </div>
      </div>
      }

      }
    </section>
  </div>
  }
</ng-scrollbar>
}
<ng-template #situationListItems let-situation>
  @if (situation.assets_range?.length > 1) {
  <li><strong>Assets</strong>: {{situation.assets_range}}</li>
  }
  @if (situation.liabilities_range?.length > 1) {
  <li><strong>Liabilities</strong>: {{situation.liabilities_range}}</li>
  }
  @if (situation.revenue_range?.length > 1) {
  <li><strong>Revenue</strong>: {{situation.revenue_range}}</li>
  }
  @if (situation.employees_range?.length > 1) {
  <li><strong>Employees</strong>: {{situation.employees_range}}</li>
  }
  @if (situation.creditors_range?.length > 1) {
  <li><strong>Creditors</strong>: {{situation.creditors_range}}</li>
  }
</ng-template>